import React, { useContext, useEffect, useState } from 'react';
import { ShopContext } from '../context/shopcontext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Sparkles } from 'lucide-react'; // Ensure you have lucide-react installed

const TrendingProducts = () => {
  const { backendUrl } = useContext(ShopContext);
  const [trending, setTrending] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });

    const cached = sessionStorage.getItem('trendingProducts');
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (Array.isArray(parsed) && parsed.length > 0) {
          setTrending(parsed);
          return;
        }
      } catch {
        sessionStorage.removeItem('trendingProducts');
      }
    }

    const fetchTrending = async () => {
      try {
        const res = await axios.get(`${backendUrl}/api/product/list`, {
          params: {
            limit: 10,
            sortField: 'clickCount',
            sortOrder: -1,
          },
        });
        const data = res.data?.products || [];
        const evenCountProducts = data.length % 2 === 0 ? data : data.slice(0, data.length - 1);
        setTrending(evenCountProducts);
        sessionStorage.setItem('trendingProducts', JSON.stringify(evenCountProducts));
      } catch (err) {
        console.error('Error fetching trending products:', err);
      }
    };

    fetchTrending();
  }, [backendUrl]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? trending.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === trending.length - 1 ? 0 : prevIndex + 1));
  };

  const handleNavigate = (productId) => {
    sessionStorage.setItem('homeScrollPosition', window.scrollY);
    navigate(`/product/${productId}`);
  };

  const currentProduct = trending[currentIndex];

  return (
    <div className="w-full px-4 sm:px-8 pt-10 pb-16 relative overflow-hidden">
      {/* Ambient background effects */}

      {/* Title */}
      {/* Section Header */}
      <div className="flex items-center justify-center mb-6 relative z-10">
        <div className="flex items-center gap-3 px-6">
          <h2
            className="text-lg sm:text-3xl md:text-4xl font-bold tracking-wider text-center"
            style={{
              fontFamily: 'Cinzel, serif',
              background: 'linear-gradient(135deg, #4c0f2e 0%, #b09287 50%, #4c0f2e 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            TRENDING
          </h2>
        </div>
      </div>

      {/* Subheading */}
      <p
        className="text-base sm:text-lg italic text-center mb-10 text-[#4c0f2e] max-w-xl mx-auto"
        style={{ fontFamily: 'Lato, sans-serif' }}
        data-aos="fade-up"
      >
        Handpicked jewels capturing attention and admiration.
      </p>

      {trending.length > 0 ? (
        <>
          {/* Mobile View: Fixed Luxurious Dome Display */}
          <div className="relative w-full max-w-4xl mx-auto block md:hidden" data-aos="zoom-in">
            <div className="relative w-full h-[420px] flex justify-center items-center">
              {/* Outer glow ring */}

              {/* Main product dome container - PROPER DOME SHAPE */}
              <div
                onClick={() => handleNavigate(currentProduct._id)}
                className="relative w-[90%] h-[450px] overflow-hidden cursor-pointer transform transition-all duration-500 hover:scale-105"
                style={{
                  borderRadius: '180px 180px 20px 20px', // Semicircle top, straight bottom
                  background: `radial-gradient(ellipse at 30% 25%, 
                    rgba(235, 226, 219, 0.9) 0%,
                    rgba(224, 195, 181, 0.8) 25%,
                    rgba(176, 146, 135, 0.7) 50%,
                    rgba(76, 15, 46, 0.6) 75%,
                    rgba(45, 22, 30, 0.8) 100%
                  )`,
                  boxShadow: `
                    inset 0 -30px 60px rgba(76, 15, 46, 0.3),
                    inset 0 30px 60px rgba(235, 226, 219, 0.2),
                    0 0 30px rgba(176, 146, 135, 0.3)
                  `,
                  border: '3px solid rgba(235, 226, 219, 0.4)',
                  borderBottom: '3px solid rgba(76, 15, 46, 0.6)', // Darker bottom edge
                  backdropFilter: 'blur(2px)',
                }}
              >
                {/* Product image with proper dome clipping */}
                <div
                  className="absolute inset-4 overflow-hidden"
                  style={{ borderRadius: '160px 160px 20px 20px' }}
                >
                  <img
                    src={currentProduct.image[0]}
                    alt={currentProduct.name}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                    style={{
                      filter: 'contrast(1.1) brightness(1.05) saturate(1.1)',
                    }}
                  />
                  {/* Glass dome effect overlay */}
                  <div
                    className="absolute inset-0 pointer-events-none"
                    style={{
                      borderRadius: '160px 160px 0 0',
                      background: `radial-gradient(ellipse at 25% 20%, 
                        rgba(255, 255, 255, 0.4) 0%,
                        rgba(235, 226, 219, 0.2) 30%,
                        rgba(176, 146, 135, 0.1) 60%,
                        transparent 80%
                      )`,
                    }}
                  ></div>
                </div>

                {/* Shop Now button repositioned for dome base */}
                <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2">
                  <button
                    className="px-6 py-2 rounded-full font-forum font-semibold text-sm transition-all duration-300 transform hover:scale-105"
                    style={{
                      background:
                        'linear-gradient(135deg, rgba(235, 226, 219, 0.95) 0%, rgba(224, 195, 181, 0.95) 100%)',
                      color: '#4c0f2e',
                      border: '1px solid rgba(176, 146, 135, 0.5)',
                      backdropFilter: 'blur(10px)',
                    }}
                  >
                    Shop Now
                  </button>
                </div>
              </div>
            </div>

            {/* Enhanced Navigation Arrows */}
            <button
              onClick={handlePrev}
              className="absolute left-2 sm:left-0 top-1/2 transform -translate-y-1/2 p-3 rounded-full transition-all duration-300 hover:scale-110 z-20"
              style={{
                background:
                  'linear-gradient(135deg, rgba(76, 15, 46, 0.9) 0%, rgba(45, 22, 30, 0.9) 100%)',
                border: '2px solid #e0c3b5',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 0 10px rgba(212, 175, 55, 0.3)',
              }}
              aria-label="Previous Image"
            >
              <svg
                className="w-4 h-4 text-[#ebe2db]"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            <button
              onClick={handleNext}
              className="absolute right-2 sm:right-0 top-1/2 transform -translate-y-1/2 p-3 rounded-full transition-all duration-300 hover:scale-110 z-20"
              style={{
                background:
                  'linear-gradient(135deg, rgba(76, 15, 46, 0.9) 0%, rgba(45, 22, 30, 0.9) 100%)',
                border: '2px solid #e0c3b5',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 0 10px rgba(212, 175, 55, 0.3)',
              }}
              aria-label="Next Image"
            >
              <svg
                className="w-4 h-4 text-[#ebe2db]"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>

            {/* Product name with enhanced styling */}
            <div
              className="text-center mt-8 font-forum text-xl font-semibold"
              style={{
                background: 'linear-gradient(135deg, #4c0f2e 0%, #b09287 50%, #4c0f2e 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {currentProduct.name}
            </div>
          </div>

          {/* Desktop View: Enhanced Luxury Dome Grid */}
          <div className="hidden md:grid grid-cols-5 gap-8 px-8 relative z-10">
            {trending.slice(0, 5).map((product, index) => (
              <div
                key={product._id}
                className="flex flex-col items-center relative"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                {/* Individual dome container - PROPER DOME SHAPE */}
                <div
                  className="relative w-full h-[450px] overflow-hidden cursor-pointer transform transition-all duration-500 hover:scale-110 group"
                  onClick={() => handleNavigate(product._id)}
                  style={{
                    borderRadius: '130px 130px 10px 10px', // Semicircle top, straight bottom
                    background: `radial-gradient(ellipse at 30% 25%, 
                      rgba(235, 226, 219, 0.9) 0%,
                      rgba(224, 195, 181, 0.8) 25%,
                      rgba(176, 146, 135, 0.7) 50%,
                      rgba(76, 15, 46, 0.6) 75%,
                      rgba(45, 22, 30, 0.8) 100%
                    )`,
                    boxShadow: `
                      inset 0 -20px 40px rgba(76, 15, 46, 0.3),
                      inset 0 20px 40px rgba(235, 226, 219, 0.2),
                      0 0 25px rgba(176, 146, 135, 0.2)
                    `,
                    border: '2px solid rgba(235, 226, 219, 0.4)',
                    borderBottom: '2px solid rgba(76, 15, 46, 0.6)', // Darker bottom edge
                    backdropFilter: 'blur(1px)',
                  }}
                >
                  {/* Product image */}
                  <div
                    className="absolute inset-3 overflow-hidden"
                    style={{ borderRadius: '110px 110px 10px 10px' }}
                  >
                    <img
                      src={product.image[0]}
                      alt={product.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      style={{
                        filter: 'contrast(1.1) brightness(1.05) saturate(1.1)',
                      }}
                    />
                    {/* Glass dome effect overlay */}
                    <div
                      className="absolute inset-0 pointer-events-none"
                      style={{
                        borderRadius: '110px 110px 0 0',
                        background: `radial-gradient(ellipse at 25% 20%, 
                          rgba(255, 255, 255, 0.3) 0%,
                          rgba(235, 226, 219, 0.15) 30%,
                          rgba(176, 146, 135, 0.1) 60%,
                          transparent 80%
                        )`,
                      }}
                    ></div>
                  </div>

                  {/* Enhanced dome highlights */}
                  <div
                    className="absolute top-8 left-8 w-6 h-6 rounded-full animate-pulse"
                    style={{
                      background:
                        'radial-gradient(circle, rgba(255, 255, 255, 0.7) 0%, rgba(235, 226, 219, 0.3) 50%, transparent 100%)',
                      animationDuration: '2s',
                      animationDelay: `${index * 0.2}s`,
                      filter: 'blur(1px)',
                    }}
                  ></div>

                  <div
                    className="absolute top-12 right-12 w-3 h-3 rounded-full animate-pulse"
                    style={{
                      background:
                        'radial-gradient(circle, rgba(255, 255, 255, 0.5) 0%, rgba(224, 195, 181, 0.2) 70%, transparent 100%)',
                      animationDuration: '1.5s',
                      animationDelay: `${index * 0.2 + 0.5}s`,
                    }}
                  ></div>
                </div>

                {/* Product name */}
                <p
                  className="text-center mt-4 text-base font-semibold font-forum max-w-[180px] truncate"
                  style={{
                    background: 'linear-gradient(135deg, #4c0f2e 0%, #b09287 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  {product.name}
                </p>

                {/* Enhanced Shop button */}
                <button
                  className="mt-3 px-5 py-2 rounded-full font-forum text-sm font-semibold transition-all duration-300 transform hover:scale-105"
                  style={{
                    background:
                      'linear-gradient(135deg, rgba(235, 226, 219, 0.95) 0%, rgba(224, 195, 181, 0.95) 100%)',
                    color: '#4c0f2e',
                    border: '1px solid rgba(176, 146, 135, 0.4)',
                    backdropFilter: 'blur(5px)',
                  }}
                >
                  Shop Now
                </button>
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="text-center text-[#b09287] font-forum text-lg" data-aos="fade-in">
          No trending products at the moment.
        </div>
      )}
    </div>
  );
};

export default TrendingProducts;
